import { Box } from '@material-ui/core';
import { getOrderDetailsByLoanId } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { OrderLines } from '@/components/modules/Cart/components/OrderLines/OrderLines';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { References } from '@/components/shared/components/References';
import { PendingDataType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const Cart = () => {
  const { loanId } = useParams();

  if (!loanId) return null;

  const { data: orderDetails, loading } = useCache(getOrderDetailsByLoanId, { loanId });

  useSetPageLoadingWhenRequesting('CART', [loading]);

  if (!orderDetails)
    return (
      <>
        <PendingDataWarning type={PendingDataType.CART} />
      </>
    );

  const references = {
    merchantOrderReference1: orderDetails.order.merchantOrderReference1,
    merchantOrderReference2: orderDetails.order.merchantOrderReference2,
  };

  return (
    <>
      <OrderLines orderDetails={orderDetails} />
      <Box mt={3} />
      <References references={references} />
    </>
  );
};

export const CartModule = withPermissionsModule(Cart);
